import AuthService from '../services/auth.service';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
  ? { status: { loggedIn: true, otp_verify:false }, user }
  : { status: { loggedIn: false, otp_verify:false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      
      return AuthService.login(user).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    otp_verify({ commit },otp_token){
      return AuthService.login_otp_verify(otp_token).then(
        otp_verify_user => {
          commit('otpVerify',otp_verify_user);
          return Promise.resolve(otp_verify_user);
        },
        error => {
          // commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        response => {
          commit('registerSuccess');
          return Promise.resolve(response.data);
        },
        error => {
          // commit('registerFailure');
          return Promise.reject(error);
        }
      );
    }
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = false;
      state.user = user;
    },
    otpVerify(state) {
      state.status.loggedIn =true;
      state.status.otp_verify = true;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
      state.status.otp_verify = true;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    }
  }
};
